import { Box, IconButton, useTheme } from '@mui/material';

import { useCommonStyles, items } from './common';

const Tablet = props => {
  const {
    lang = '',
    switchLang = () => {},
  } = props;

  const style = useCommonStyles(useTheme());
  const { flag: flagStyle } = style;

  const enStyle = lang === 'en' ? style.flagEN : {};

  return (
    <Box sx={{ display: { sm: 'flex', xs: 'none' } }}>
      {Object.keys(items).map(key => (
        <IconButton
          key={key}
          sx={style.link}
          size="small"
          title={key}
          href={items[key].href}
          target="_blank"
        >
          {items[key].icon}
        </IconButton>
      ))}
      <IconButton onClick={switchLang} sx={style.link}>
        <Box sx={{ ...flagStyle, ...enStyle }} />
      </IconButton>
    </Box>
  );
};

export default Tablet;